import { ShapeTypes } from '@i-ark/models';
import { logger } from '@i-ark/utils';
import { ArrowButtonShape } from './ArrowButtonShape.js';
import { ArrowShape } from './ArrowShape.js';
import { CircleOutlinedShape } from './CircleOutlinedShape.js';
import { CircleShape } from './CircleShape.js';
import { DiagramArrowCornerPointLeftShape } from './DiagramArrowCornerPointLeftShape.js';
import { DiagramArrowCornerPointRightShape } from './DiagramArrowCornerPointRightShape.js';
import { DiagramArrowLeftShape } from './DiagramArrowLeftShape.js';
import { DiagramArrowRightShape } from './DiagramArrowRightShape.js';
import { DiagramArrowUpShape } from './DiagramArrowUpShape.js';
import { Diamond2Shape } from './Diamond2Shape.js';
import { DiamondShape } from './DiamondShape.js';
import { EllipseShape } from './EllipseShape.js';
import { FlowerShape } from './FlowerShape.js';
import { GeometricShape } from './GeometricShape.js';
import { HeartShape } from './HeartShape.js';
import { HeptagonShape } from './HeptagonShape.js';
import { HexagonShape } from './HexagonShape.js';
import { KiteShape } from './KiteShape.js';
import { MoonShape } from './MoonShape.js';
import { NonagonShape } from './NonagonShape.js';
import { OctagonShape } from './OctagonShape.js';
import { PentagonShape } from './PentagonShape.js';
import { PieChartShape } from './PieChartShape.js';
import { PlusShape } from './PlusShape.js';
import { RectangleOutlinedShape } from './RectangleOutlinedShape.js';
import { RectangleShape } from './RectangleShape.js';
import { SemiCircleShape } from './SemiCircleShape.js';
import { SignShape } from './SignShape.js';
import { SpiralShape } from './SpiralShape.js';
import { SquareShape } from './SquareShape.js';
import { StarShape } from './StarShape.js';
import { TrefoilShape } from './TrefoilShape.js';
import { Triangle2Shape } from './Triangle2Shape.js';
import { TriangleOutlinedShape } from './TriangleOutlinedShape.js';
import { TriangleShape } from './TriangleShape.js';
import { VerticalLineShape } from './VerticalLineShape.js';
import { jsx } from 'react/jsx-runtime';

const RenderShape = ({
  type,
  ...shapeProps
}) => {
  switch (type) {
    case ShapeTypes.ARROW_BUTTON:
      return /*#__PURE__*/jsx(ArrowButtonShape, {
        ...shapeProps
      });
    case ShapeTypes.ARROW:
      return /*#__PURE__*/jsx(ArrowShape, {
        ...shapeProps
      });
    case ShapeTypes.CIRCLE:
      return /*#__PURE__*/jsx(CircleShape, {
        ...shapeProps
      });
    case ShapeTypes.CIRCLE_OUTLINED:
      return /*#__PURE__*/jsx(CircleOutlinedShape, {
        ...shapeProps
      });
    case ShapeTypes.DIAGRAM_ARROW_CORNER_POINT_LEFT:
      return /*#__PURE__*/jsx(DiagramArrowCornerPointLeftShape, {
        ...shapeProps
      });
    case ShapeTypes.DIAGRAM_ARROW_CORNER_POINT_RIGHT:
      return /*#__PURE__*/jsx(DiagramArrowCornerPointRightShape, {
        ...shapeProps
      });
    case ShapeTypes.DIAGRAM_ARROW_UP:
      return /*#__PURE__*/jsx(DiagramArrowUpShape, {
        ...shapeProps
      });
    case ShapeTypes.DIAGRAM_ARROW_RIGHT:
      return /*#__PURE__*/jsx(DiagramArrowRightShape, {
        ...shapeProps
      });
    case ShapeTypes.DIAGRAM_ARROW_LEFT:
      return /*#__PURE__*/jsx(DiagramArrowLeftShape, {
        ...shapeProps
      });
    case ShapeTypes.DIAMOND2:
      return /*#__PURE__*/jsx(Diamond2Shape, {
        ...shapeProps
      });
    case ShapeTypes.DIAMOND:
      return /*#__PURE__*/jsx(DiamondShape, {
        ...shapeProps
      });
    case ShapeTypes.ELLIPSE:
      return /*#__PURE__*/jsx(EllipseShape, {
        ...shapeProps
      });
    case ShapeTypes.FLOWER:
      return /*#__PURE__*/jsx(FlowerShape, {
        ...shapeProps
      });
    case ShapeTypes.RECTANGLE:
      return /*#__PURE__*/jsx(RectangleShape, {
        ...shapeProps
      });
    case ShapeTypes.RECTANGLE_OUTLINED:
      return /*#__PURE__*/jsx(RectangleOutlinedShape, {
        ...shapeProps
      });
    case ShapeTypes.PENTAGON:
      return /*#__PURE__*/jsx(PentagonShape, {
        ...shapeProps
      });
    case ShapeTypes.GEOMETRIC:
      return /*#__PURE__*/jsx(GeometricShape, {
        ...shapeProps
      });
    case ShapeTypes.HEART:
      return /*#__PURE__*/jsx(HeartShape, {
        ...shapeProps
      });
    case ShapeTypes.HEPTAGON:
      return /*#__PURE__*/jsx(HeptagonShape, {
        ...shapeProps
      });
    case ShapeTypes.HEXAGON:
      return /*#__PURE__*/jsx(HexagonShape, {
        ...shapeProps
      });
    case ShapeTypes.KITE:
      return /*#__PURE__*/jsx(KiteShape, {
        ...shapeProps
      });
    case ShapeTypes.MOON:
      return /*#__PURE__*/jsx(MoonShape, {
        ...shapeProps
      });
    case ShapeTypes.NONAGON:
      return /*#__PURE__*/jsx(NonagonShape, {
        ...shapeProps
      });
    case ShapeTypes.OCTAGON:
      return /*#__PURE__*/jsx(OctagonShape, {
        ...shapeProps
      });
    case ShapeTypes.PIE_CHART:
      return /*#__PURE__*/jsx(PieChartShape, {
        ...shapeProps
      });
    case ShapeTypes.PLUS:
      return /*#__PURE__*/jsx(PlusShape, {
        ...shapeProps
      });
    case ShapeTypes.SEMI_CIRCLE:
      return /*#__PURE__*/jsx(SemiCircleShape, {
        ...shapeProps
      });
    case ShapeTypes.SIGN:
      return /*#__PURE__*/jsx(SignShape, {
        ...shapeProps
      });
    case ShapeTypes.SPIRAL:
      return /*#__PURE__*/jsx(SpiralShape, {
        ...shapeProps
      });
    case ShapeTypes.SQUARE:
      return /*#__PURE__*/jsx(SquareShape, {
        ...shapeProps
      });
    case ShapeTypes.STAR:
      return /*#__PURE__*/jsx(StarShape, {
        ...shapeProps
      });
    case ShapeTypes.TREFOIL:
      return /*#__PURE__*/jsx(TrefoilShape, {
        ...shapeProps
      });
    case ShapeTypes.TRIANGLE2:
      return /*#__PURE__*/jsx(Triangle2Shape, {
        ...shapeProps
      });
    case ShapeTypes.TRIANGLE:
      return /*#__PURE__*/jsx(TriangleShape, {
        ...shapeProps
      });
    case ShapeTypes.TRIANGLE_OUTLINED:
      return /*#__PURE__*/jsx(TriangleOutlinedShape, {
        ...shapeProps
      });
    case ShapeTypes.VERTICAL_LINE:
      return /*#__PURE__*/jsx(VerticalLineShape, {
        ...shapeProps
      });
    default:
      logger.warn("<RenderShape />: Attempting to render unknown shape type:", type);
      return null;
  }
};

export { RenderShape };
//# sourceMappingURL=RenderShape.js.map
